var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnMenuUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "feather feather-menu",
    width: 20.057,
    height: 14.586,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 20.057 14.586",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.753 0.33858c-0.2091-0.21487-0.50048-0.33858-0.80899-0.33858-0.30852 0-0.59989 0.12371-0.809 0.33858l-3.0166 3.1253c-0.40793 0.42322-0.3805 1.0841 0.06855 1.4715 0.44906 0.38741 1.1416 0.36137 1.5495-0.065101l1.1107-1.1492v9.8221c0 0.57625 0.49021 1.0418 1.0969 1.0418 0.60676 0 1.0969-0.46556 1.0969-1.0418v-9.8221l1.1107 1.1525c0.40793 0.42323 1.1038 0.45252 1.5495 0.065112 0.44562-0.38741 0.47648-1.0483 0.06856-1.4715l-3.0166-3.1253z",
    fill: "#fff",
    stroke: "none",
    strokeWidth: 0.4677
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5214 0 0 1.0418 -1.0428 -5.209)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 21,
    y1: 18,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 21,
    y1: 6,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 21,
    y1: 12,
    y2: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMenuUp);
export default __webpack_public_path__ + "static/media/icn-menu-up.f0467e048aee346cbd42a61afb0783ab.svg";
export { ForwardRef as ReactComponent };